<template>
    <v-card class="pa-3" height="100%">
        <apexchart
        type="pie"
        height="360"
        :options="chart.gender.options"
        :series="chart.gender.series"
        ></apexchart>
    </v-card>
</template>
<script>
  import { mapGetters } from "vuex";  
  import VueApexCharts from "vue-apexcharts";

  export default {
    components: {
      apexchart: VueApexCharts,
    },
  data: () => ({
      chart: {
        gender: {
            series: [],
            options: {
                title: {
                text: "Dasher Gender Overview",
                },
                noData: {
                text: "No data available",
                },
                chart: {
                type: "pie",
                toolbar: {
                    show: true,
                },
                },
                labels: [],
                colors: [
                "#00a0de",
                "#71974c",
                "#d34626",
                ],
                legend: {
                show: true,
                position: "bottom",
                },
            },
        },
      }

    }),

    created() {
      // this.initialize();
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"])
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["gender-report"]);
        this.updateCharts();
      },

      async updateCharts() {
        // AGE Overview PIE Chart    
        this.chart.gender.options = {
          labels: this.indexData.dasherGender_overview.labels,
        };
        // Pie Chart has animaion issue. If the new series contains
        // more items then the animation doesn't work. To fix it
        // we first set the series dammy data, wait 50ms, and then
        // set with actual data  
        let fetched_data = this.indexData.dasherGender_overview.series;
        
        this.chart.gender.series = [1].concat(Array(fetched_data.length).fill(0));

        setTimeout(() => {
          this.chart.gender.series = fetched_data;
        }, 500);
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>